export const pipe = (...fns) => (x) => fns.reduce((v, f) => f(v), x);
export const anyPass = (...fns) => x => fns.map(fn => fn(x)).reduce((accum, current) => accum || current);
export const allPass = (...fns) => x => fns.map(fn => fn(x)).reduce((accum, current) => accum && current);
export const not = fn => x => !fn(x);
export const isNull = x => x === null;
export const isUndefined = x => x === undefined;
export const isEmpty = x => x == '';
export const tap = (fn = () => {}) => arg => {console.log('tap:', arg);fn();return arg};
export const flow = fn => arg => {fn(arg);return arg};
